import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'src/app/global';

@Injectable({
  providedIn: 'root'
})
export class EscenariosService {

  constructor(private http: HttpClient) { }

  public obtenerListaEscenarios(paginator){
      return this.http.get(GlobalVariable.API_SERVER_URL+"escenarios/empresa/"+paginator.filter.id_empresa+"/pagina/"+paginator.currentPage+"/items-pagina/"+paginator.itemsPerPage+"/busqueda/"+paginator.search+"/columna/"+paginator.column+"/direccion/"+paginator.direction,GlobalVariable.httpOptions);
  }

  public guardarEscenario(escenario){
    return this.http.post(GlobalVariable.API_SERVER_URL+"escenarios",escenario, GlobalVariable.httpOptions);
  }

  public actualizarEscenario(escenario){
    return this.http.put(GlobalVariable.API_SERVER_URL+"escenarios/"+escenario.id,escenario, GlobalVariable.httpOptions);
  }

  public obtenerDisponibilidadEscenario(id_escenario){
    return this.http.get(GlobalVariable.API_SERVER_URL+"escenario-disponibilidad/escenario/"+id_escenario,GlobalVariable.httpOptions);
  }

  public actualizarDisponibilidadEscenario(id_escenario,disponibilidades){
    return this.http.put(GlobalVariable.API_SERVER_URL+"escenario-disponibilidad/escenario/"+id_escenario,
                         {disponibilidades:disponibilidades},GlobalVariable.httpOptions);
  }

  public obtenerEscenariosConDisponibilidad(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"escenarios-disponibilidad/empresa/"+id_empresa,GlobalVariable.httpOptions);
  }
}
